import axios from "axios"
import { toaster as estimateMountedToaster } from "baseui/toast"
import { NextApiResponse } from "next"

export function getErrorMessage(err: any) {
  if (axios.isAxiosError(err)) {
    return (
      err!.response?.data.userErrorMessage ||
      err!.response?.data.errorMessage ||
      "알 수 없는 오류 발생"
    )
  } else if (err instanceof Error) {
    return err.message
  } else {
    return "알 수 없는 오류 발생"
  }
}

export function getErrorCode(err: any) {
  if (axios.isAxiosError(err)) {
    return (err!.response?.data.errorCode as string) ?? undefined
  }
  return undefined
}

export function getHttpResponseCode(err: any) {
  if (axios.isAxiosError(err)) {
    return err!.response?.status ?? 500
  }
  return 500
}

export function wrapErrorToNextApiResponse(res: NextApiResponse, err: any) {
  if (axios.isAxiosError(err)) {
    res.status(err.response?.status || 500).json({
      errorCode: err.response?.data.errorCode,
      userErrorMessage: err.response?.data.userErrorMessage,
      errorMessage: err.response?.data.errorMessage || "알 수 없는 오류 발생",
    })
  } else {
    debugger
    res.status(500).json({
      userErrorMessage: "알 수 없는 오류 발생",
      errorMessage: "알 수 없는 오류 발생",
    })
  }
}

export type ToastConfig = {
  errorMessagePrefix?: string
  successMessage?: string
}

/**
 * react portal등에 의해 main-tree에서 벗어난 곳에서 해당 메서드를 호출할 경우,
 * 해당 파일 내에서 import된 toaster는 main-tree에 선언되어 있는 Context는 찾지못해 하기 에러가 발생.
 * Error: Please make sure to add the ToasterContainer to your application, and it is mounted, before adding toasts!
 * exception이 발생하나 실제로 ToasterContainer는 존재하기에 에러 토스트는 출력되는 기이한 버그 발견.
 * 해당 버그에 대한 해결책으로 optional로 mount된 toaster를 직접 prop으로 내려받을 수 있도록 추가
 */
export async function wrapWithToast<T>(
  fn: () => Promise<T>,
  toastConfig: ToastConfig = {},
  toaster: typeof estimateMountedToaster = estimateMountedToaster
): Promise<T> {
  try {
    const res = await fn()
    if (toastConfig.successMessage) {
      toaster.positive(toastConfig.successMessage)
    }
    return res
  } catch (err) {
    if (axios.isAxiosError(err)) {
      const errMsgPrefix = toastConfig.errorMessagePrefix || ""
      toaster.negative(`${errMsgPrefix} ${getErrorMessage(err)}`, {
        autoHideDuration: 10000,
      })
    } else {
      toaster.negative(`${err}`, {
        autoHideDuration: 10000,
      })
    }
    throw err
  }
}
